<template>
  <div id="newsdetail">
    <div class="page_tit_box">
      <div class="center_content u-flex">
        <div>
          <img class="tit_img" src="../../assets/images/index_icon1.png" alt="">
        </div>
        <div>首页>项目查询>项目详情</div>
      </div>
    </div>
    <div class="center_box">
      <div class="detail_tit">项目详情</div>

      <div class="detail_stit">项目信息</div>
      <div class="detail_sbox">
        <span>项目名称：</span>{{NewDetail.name}}<br>
        <span>工程类型：</span>{{NewDetail.type}}<br>
        <span>开标日期：</span>{{NewDetail.kbDate}}<br>
        <span>计划工期：</span>{{NewDetail.jihuagongqi}}<br>
        <span>项目地点：</span>{{NewDetail.kbAddress}}<br>
      </div>

      <div class="detail_stit">招标人信息</div>
      <div class="detail_sbox">
        <span>招标单位名称：</span>{{NewDetail.zbDwname}}<br>
        <span>联系人：</span>{{NewDetail.zbLixiren}}<br>
        <span>联系电话：</span>{{NewDetail.zbPhone}}<br>
        <span>招标文件编号：</span>{{NewDetail.zbWjbh}}<br>
        <span>联系地址：</span>{{NewDetail.zbAdress}}<br>
      </div>

      <div class="detail_stit">投标保证保函</div>
      <div class="detail_sbox">
        <span>保证金金额(元)：</span>{{NewDetail.bhMoney}}<br>
        <span>保函申请开始时间：</span>{{NewDetail.bhStartDate}}<br>
        <span>电子保函申请截止时间：</span>{{NewDetail.bhEndDate}}<br>
      </div>

      <div class="certbtn_box">
        <el-button class="certbtn" type="primary" @click="goDetail(NewDetail.id)">开具保函</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import Qs from "qs";
import  {sesStorage}  from '@/model/storage.js'
export default {
  data() {
    return {
      NewDetail: {},
    };
  },
  components: {},
  methods: {
    goDetail(id){
      let data = {
        id: id,
        token: sesStorage.get('userObj').token,
      };
      this.$http
        .post("/front/project/kjBanhan", Qs.stringify(data))
        .then((res) => {
          if (res.data.code == 0) {
            if(res.data.data.renzheng=='2'){
              this.$router.push({
                path:'/home/Detail',
                query:{
                  obj:res.data.data,
                  id: id,
                  project:this.NewDetail
                }
              })
            }else{
              this.$router.push({path:'/home/certification'})
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              center: true,
            });
            if(res.data.code == 201){
              setTimeout(()=>{
                this.$router.push({path:'/home/login'})
              },1000)
            }
            // if(res.data.code == 301){
            //   setTimeout(()=>{
            //     this.$router.push({path:'/home/certification'})
            //   },1000)
            // }
          }
        })



       


    }
  },
  mounted() {
    let data = {
      id: this.$route.query.id,
      token: sesStorage.get('userObj').token,
    };
    this.$http
      .post("/front/project/getProject", Qs.stringify(data))
      .then((res) => {
        if (res.data.code == 0) {
          this.NewDetail=res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
            center: true,
          });
          if(res.data.code == 201){
              setTimeout(()=>{
                this.$router.push({path:'/home/login'})
              },1000)
            }
        }
      })
      .catch((error) => {});
  },
  watch: {},
};
</script>


<style lang="scss">
#newsdetail {
  .page_tit_box {
    background: #e2e4ee;
    padding: 20px 0;
    font-size: 14px;
  }
  .center_content {
    width: 1500px;
    margin: 0 auto;
    .tit_img{
      width: 14px;
      height: 18px;
      margin-right: 16px;
    }
  }
  .center_box {
    width: 1500px;
    margin: 20px auto 0 auto;
    overflow: hidden;
    padding: 30px 35px 10px 35px;
    background: #fff;
    .detail_tit{
      font-size: 24px;
      text-align: center;
      font-weight: bold;
    }
    .detail_stit{
      font-size: 16px;
      font-weight: bold;
      padding-left: 14px;
      border-left: 4px solid #FF8D24;
      margin-top: 30px;
    }
    .detail_sbox{
      margin-top: 20px;
      background-color: #F5F6FA;
      padding: 20px;
      line-height: 32px;
      font-size: 16px;
      span{
        color: #8A8A8B;
      }
    }

    .certbtn_box {
      width: 340px;
      margin: 42px auto;
    }
    .certbtn {
      height: 42px;
      background: #303643;
      border-radius: 2px;
      color: #fff;
      border: none;
      width: 100%;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/project/projectDetail.vue